<template>
	<ListPage :query="query" :total="total" v-loading="loading" :data="tableData" @size-change="handleSizeChange"
		@current-change="handleCurrentChange" @search="handleSearch" @reset="resetQuery">
		<template slot="filters">
			<el-form-item label="角色名称" prop="keywords">
				<el-input v-model="query.keywords" placeholder="请输入角色名称" clearable @keyup.enter.native="handleSearch" />
			</el-form-item>
		</template>
		<template slot="btns" v-if="permission('/permission/role/list/add')">
			<el-button icon="el-icon-plus" size="mini" type="primary" @click="handleAdd">
				新增角色
			</el-button>
		</template>
		<template slot="columns">
			<el-table-column label="序号" align="center" type="index" width="100" />
			<el-table-column label="角色名称" align="center" prop="roleName" />
			<el-table-column label="创建时间" align="center" prop="createTime">
				<template slot-scope="{ row }">
					{{ formatDate(row.createTime) }}
				</template>
			</el-table-column>
			<el-table-column label="操作" align="center" width="200"
				v-if="permission('/permission/role/list/edit') || permission('/permission/role/list/delete')">
				<template slot-scope="{ row }">
					<el-link v-if="permission('/permission/role/list/edit')" style="margin: 0 10px" :underline="false"
						type="primary" @click="handleEdit(row)">
						编辑
					</el-link>
					<el-link v-if="permission('/permission/role/list/delete')" :underline="false" type="danger"
						@click="handleDel(row)">
						删除
					</el-link>
				</template>
			</el-table-column>
		</template>
	</ListPage>
</template>

<script>
import { page, del } from "@/api/permission/role";
import listMixin from '@/mixins/list';

export default {
	data() {
		return {
			// 查询参数
			query: {
				keywords: "",
			},
		};
	},
	mixins: [listMixin],
	methods: {
		search() {
			this.loading = true;
			const params = {
				...this.query,
			};
			page(params).then(({ code, result, message }) => {
				if (code == 200) {
					this.tableData = result.records;
					this.total = result.total;
				} else {
					this.$message.error(message);
				}
				this.loading = false;
			});
		},
		handleAdd() {
			this.$router.push("/permission/role/form");
		},
		handleEdit(row) {
			this.$router.push({ path: "/permission/role/form", query: { id: row.id } });
		},
		handleConfig(row) {
			this.$router.push({ path: "/permission/role/config", query: { id: row.id } });
		},
		handleDel(row) {
			this.$confirm("是否删除该角色?", "提示", {
				type: "warning",
			})
				.then(() => {
					del({ id: row.id }).then(({ code, message }) => {
						if (code == 200) {
							this.$message.success("删除成功");
							this.search();
						} else {
							this.$message.error(message);
						}
					});
				})
				.catch(() => { });
		},
	},
};
</script>